import script from "./PainelFinanceiro.vue?vue&type=script&setup=true&lang=js"
export * from "./PainelFinanceiro.vue?vue&type=script&setup=true&lang=js"

import "./PainelFinanceiro.vue?vue&type=style&index=0&id=6fa9ffc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa9ffc1"]])

export default __exports__